import ImageCompressor from 'browser-image-compression';

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';

import { ImageFile } from '@personal-area/global/common';
import { AbstractFileAttachComponent } from './abstract.file-attach.component';
import { ErrorType } from './attachment';
import { MIME_TYPES } from './attachment';

@Component({
  selector: 'global-file-attach',
  templateUrl: './file-attach.component.html',
  styleUrls: ['./file-attach.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileAttachControlComponent extends AbstractFileAttachComponent {
  @Output() downloadLabelClicked = new EventEmitter<void>();
  @Output() addingFileStart = new EventEmitter<void>();
  @Output() addingFileEnd = new EventEmitter<void>();

  protected override async _renderPreview(file: ImageFile, src: string, nativeFile: File): Promise<void> {
    let compressedImage: File;

    try {
      compressedImage = await ImageCompressor(nativeFile, {
        maxSizeMB: this._settings.allowedFileSize / (1024*1024),
        preserveExif: true,
        useWebWorker: true,
      });
    } catch (error: unknown) {
      this._onImageLoadFail(file);
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      if (!reader.result) {
        // MDN: The value is null if the reading is not yet complete or was unsuccessful.
        this.errorOccurred.next(ErrorType.FileReaderResultNull);
        this._onImageLoadFail(file);
        return;
      }
      this._handleFile({
        ...file,
        imageSrc: reader.result as string,
      }, compressedImage);
    };
    reader.onerror = () => this._onImageLoadFail(file);
    reader.readAsDataURL(compressedImage);
  }

  public override attachFiles(target: EventTarget | DataTransfer | null): void {
    const files = (target as HTMLInputElement).files
    if (files) {
      this._processingFiles = true;
      this.ctrl?.markAsDirty();

      Array.from(files).forEach((file: File) => {
        if (file.name.toLowerCase().includes('bmp')) {
          file = new File([file], file.name, { type: MIME_TYPES.bmp })
        }
        this._generateImageFile(file,
          (file.type === MIME_TYPES.pdf && file.size > this.settings.allowedFileSize) || (file.type === this.settings.customFileParameters?.type && file.size > this.settings.customFileParameters?.maxSize),
          !this.settings.allowedContentTypes.includes(file.type as MIME_TYPES));
      });
      this._processingFiles = false;
    }
    this._clearFileInput();
    this._cdRef.markForCheck();
  }
}
